<mat-card style="height: 100%">
    <mat-card-content>
        <div style="overflow-y: auto">
            <table mat-table [dataSource]="dataSourceSubscription" style="width: 100%; height: 100%" matSort>
                <ng-container matColumnDef="SubscriptionKey">
                    <tr>
                        <td mat-header-cell *matHeaderCellDef>
                            <div style="display: flex; justify-content: space-between; padding-bottom: 1.2rem">
                                <div style="justify-content: flex-start">
                                    <div class="titleTabContent"><span translate>MULTICOMPANY</span></div>
                                    <br />
                                    <div class="titleGray">
                                        <span translate>LEADING_COMPANY</span>
                                        <span> : {{ currentsubscriptionDescri }} ( {{ currentsubscriptionKey }} )</span>
                                    </div>
                                </div>
                                <div>
                                    <button
                                        *ngIf="this.havePermission"
                                        mat-flat-button
                                        color="primary"
                                        style="padding: 0 20px"
                                        (click)="redirectToSlaveManagement()"
                                        class="button-icon-text"
                                        [disabled]="setDisabled()"
                                    >
                                        <mat-icon>add</mat-icon>
                                        <span style="padding: 0.2rem; font-size: 1rem" translate>ADD_SLAVE_SUBSCRIPTION</span>
                                    </button>
                                </div>
                            </div>
                            <div class="message-box info" *ngIf="setDisabled()">
                                <span translate>SLAVE_SUBSCRIPTION_NOT_AVAILABLE</span>
                            </div>
                            <h6><span translate>SLAVE_SUBSCRIPTION_INTRO</span></h6>
                            <h6><span translate>SLAVE_SUBSCRIPTION_DESCRI</span></h6>
                            <h6><span translate>SLAVE_SUBSCRIPTION_INSTRUCTION</span> {{ this.mail }}</h6>
                            <div *ngIf="this.subscriptionT?.length > 0" style="display: flex; padding-top: 2rem">
                                <h6><span style="font-weight: 600" translate>SLAVE_SUBSCRIPTION_LIST_COMPANY</span></h6>
                            </div>
                            <div *ngIf="this.subscriptionT?.length == 0"><span translate>M_SUB_MULTI_NOT_FOUND</span></div>
                        </td>
                        <td mat-cell *matCellDef="let row">
                            <div>
                                <input
                                    matInput
                                    style="cursor: pointer"
                                    [readonly]="true"
                                    value="{{ row.Description }} ( {{ row.SubscriptionKey }} )"
                                    name="Subscription Root"
                                    (click)="onClickSubKey(row.SubscriptionKey)"
                                />
                            </div>
                        </td>
                    </tr>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnsSubscription"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsSubscription" class="pointer"></tr>
            </table>
        </div>
    </mat-card-content>
</mat-card>
